import React from "react";
import { Button, Flex, Text } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobOpportunityCard = props => {
  var {
    title,
    subTitle,
    contentLeft,
    contentRight,
    btnUrl,
    btnText = "Learn more"
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "jobopportunity_card",
    children: [/*#__PURE__*/_jsx("div", {
      className: "p-5 text-primary bg-primary",
      children: /*#__PURE__*/_jsx("h3", {
        className: "m-0",
        children: title
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "px-5 py-3 bg-[#F5F5F5]",
      children: /*#__PURE__*/_jsx("p", {
        className: "m-0 lg:text-lg",
        children: subTitle
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      className: "p-5",
      justify: "start",
      align: "center",
      gap: "4",
      children: [/*#__PURE__*/_jsx(Text, {
        className: "" + (contentRight ? "sm:w-[48%] [&>ul]:list-outside" : "w-full"),
        children: contentLeft
      }), contentRight && /*#__PURE__*/_jsx(Text, {
        className: "sm:w-[48%]",
        children: contentRight
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "p-5",
      children: /*#__PURE__*/_jsx(Button, {
        color: "tertiary",
        href: btnUrl,
        children: btnText
      })
    })]
  });
};
//# sourceMappingURL=jobopportunity_card.js.map